export default {
    isSaved: false,
    validated: false,
    data: null
}